import React from "react";
import iconvideo from "../../img/icons-ext-file/iconVideo.png"

export default function FileVideo() {
    return (
        <img src={iconvideo} alt="" />
    );
}